import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { payslipListRequest } from '../../../redux/payroll/payroll.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const PayslipList = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { payslipListSuccess, payslipListError } = useSelector(state => state.payroll)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const { state } = useLocation()
    let navigate = useNavigate();

    useEffect(() => {
        if (isLoggedInUserBusiness(user) && !(!isEmpty(state.fromRoute) && state.fromRoute === 'employeeList')) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.PAY_SLIP_LIST, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchPayslip()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(payslipListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(payslipListError)) {
            setLoading(false)
        }
    }, [payslipListSuccess, payslipListError])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.PAY_SLIP_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.PAY_SLIP_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            fetchPayslip()
        }
    }, [selectedLocation])

    const fetchPayslip = () => {
        if (isLoggedInUserEmployee(user) && isEmpty(employeeSelectedBusiness) && isEmpty(employeeSelectedLocation)) {
            return
        }
        setLoading(true)
        let data = {
            employeeId: state.employeeId
        }
        if (!isEmpty(state.fromRoute) && state.fromRoute === 'employeeList' &&
            !isEmpty(state.businessId) && !isEmpty(state.locationId)) {
            data.businessId = state.businessId
            data.locationId = state.locationId
        } else {
            if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) &&
                !isEmpty(selectedLocation)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            } else if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) &&
                !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
        }
        dispatch(payslipListRequest(data))
    }

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.PAYROLL, PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL, employeeSelectedBusiness, employeeSelectedLocation)
    }

    const handleNewPayslipClick = () => {
        let data = {
            employeeId: state.employeeId,
            firstName: (!isEmpty(state.fromRoute) && state.fromRoute === 'payrollMenu') ? user.data.userDetails.firstName : state.firstName,
            lastName: (!isEmpty(state.fromRoute) && state.fromRoute === 'payrollMenu') ? user.data.userDetails.lastName : state.lastName,
        }
        if (!isEmpty(state.fromRoute) && state.fromRoute === 'employeeList' &&
            !isEmpty(state.businessId) && !isEmpty(state.locationId)) {
            data.businessId = state.businessId
            data.locationId = state.locationId
        } else {
            if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) &&
                !isEmpty(selectedLocation)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            } else if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) &&
                !isEmpty(employeeSelectedLocation)) {
                data.businessId = employeeSelectedBusiness
                data.locationId = employeeSelectedLocation
            }
        }
        navigate(ROUTES.payroll.newPayroll, {
            state: data
        })
    }

    const handleDetailsClick = (item) => {
        navigate(ROUTES.payroll.payslipDetail, { state: item.employeePayrollId })
    }

    const showButton = () => {
        if (!isEmpty(state) && state.fromRoute === 'payrollMenu') {
            return false
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(state.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
                return false
            }
        }
        return true
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Payslips' />
                {isLoggedInUserBusiness(user) === true && !(!isEmpty(state.fromRoute) && state.fromRoute === 'employeeList') && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isEmpty(payslipListSuccess) && !isEmpty(payslipListSuccess.data) && <div className="table-scroll-container">
                    <table className="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Month</th>
                                <th scope="col" className="text-center">Basic Salary</th>
                                <th scope="col" className="text-center">Net Salary</th>
                                <th scope="col" className="text-center">Duration Type</th>
                                <th scope="col" className="text-center">Payment Status</th>
                                <th scope="col" className="text-center">Working Days</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payslipListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.month}, {element.year}</td>
                                    <td className="text-center">{element.basicSalary}</td>
                                    <td className="text-center">{element.netSalary}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.salaryType)}</td>
                                    <td className="text-center">{element.paymentStatus}</td>
                                    <td className="text-center">{element.meta.presentDays}/{element.meta.workingDays}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleDetailsClick(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(payslipListError) && <div className="content-error">{payslipListError.message}</div>}
                {isPermissionAllowed() && showButton() &&
                    <div className="vl-fab-container" onClick={() => handleNewPayslipClick()}>
                        <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PayslipList